import React from 'react';

var Edit = function Edit(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14.422 7.405l-9.908 10.26v1.948h2.21l9.85-10.057-2.152-2.15zm1.39-1.439l2.16 2.161 1.522-1.553-2.209-2.133-1.473 1.525zM2.5 16.872L16.083 2.807a1.66 1.66 0 0 1 2.347-.041l2.698 2.606a1.66 1.66 0 0 1 .041 2.347L7.587 21.613H2.5v-4.74z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Edit.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { Edit as icon };
export default iconHandler(Edit);